import { action } from 'satcheljs';
import Folder from '../store/schema/Folder';
import FindFolderParentWrapper from 'owa-service/lib/contract/FindFolderParentWrapper';
import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';
import { FolderForestTreeType } from 'owa-favorites-types';

/**
 * Action to set mailbox data.
 */
export const setMailboxData = action(
    'SET_MAILBOX_DATA',
    (mailboxId: string, folderValue: Folder, loadingState: MailboxLoadStateEnum) => ({
        mailboxId,
        folderValue,
        loadingState,
    })
);

/**
 * Action to remove mailbox data.
 */
export const removeMailboxData = action('REMOVE_MAILBOX_DATA', (mailboxId: string) => ({
    mailboxId,
}));

/**
 * Action to set loading state for mailbox.
 */
export const setLoadingStateForMailbox = action(
    'SET_LOADING_STATE_FOR_MAILBOX',
    (mailboxId: string, loadingState: MailboxLoadStateEnum) => ({
        mailboxId,
        loadingState,
    })
);

/**
 * Action to set root folder display name.
 */
export const setRootFolderDisplayNameForMailbox = action(
    'SET_ROOT_FOLDER_DISPLAY_NAME_FOR_MAILBOX',
    (mailboxId: string, displayName: string) => ({ mailboxId, displayName })
);

/**
 * Action to update folder table.
 */
export const updateFolderTable = action(
    'UPDATE_FOLDER_TABLE',
    (
        folder: FindFolderParentWrapper,
        treeType: FolderForestTreeType,
        principalSMTPAddress: string
    ) => ({ folder, treeType, principalSMTPAddress })
);

/**
 * Action to fetch archive recoverable items (dumpster) folder
 */
export const fetchArchiveDumpsterFolder = action('FETCH_ARCHIVE_DUMPSTER_FOLDER');

/**
 * Action to add shared folder user email
 */
export const addSharedFolderUserEmail = action(
    'ADD_SHARED_FOLDER_USER_EMAIL',
    (principalSMTPAddress: string) => ({ principalSMTPAddress })
);

/**
 * Action to remove shared folder user email
 */
export const removeSharedFolderUserEmail = action(
    'REMOVE_SHARED_FOLDER_USER_EMAIL',
    (principalSMTPAddress: string) => ({ principalSMTPAddress })
);
